import productFamily from './pmp_families.json';

export const getProductFamily = (product) => {
  if (productFamily[product]) {
    return productFamily[product];
  } else {
    return 'PMP-450';
  }
};
